import { css } from "lit";

export const stickyButtonContainerStyles = css`
  :host {
    box-sizing: border-box;
    position: sticky;
    bottom: 0;
    width: 100%;
    background: var(--sds-color-background-default-default);
    padding: var(--sds-size-space-800);
    border-top: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
  }

  .container {
    --local-size-reduction: calc(var(--sds-size-space-800) * 2);

    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    width: calc(100% - var(--local-size-reduction));
    max-width: calc(393px - var(--local-size-reduction));
    margin: 0 auto;
  }

  .container.horizontal {
    flex-direction: row;
  }

  @media (min-width: 1200px) {
    :host([desktop-static]) {
      position: inherit;
      border-top: none;
      padding-top: 0;
    }
  }
`;
